import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/tipoObra/';

class TipoObraService{
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    findTipoObraByFiltro(idCliente, filtro){
        return axios.get(API_URL + 'allTipoObra?idCliente='+idCliente+'&filtro='+filtro, {headers: this.headers});
    }

    getTipoObra(id){
        console.log(id);
        return axios.get(API_URL + id, {headers: this.headers});
    }

    saveTipoObra(tipoObra){
        return axios.post(API_URL, JSON.stringify(tipoObra), {headers: this.headers});
    }

    removeTipoObra(id){
        return axios.delete(API_URL+ id, {headers: this.headers});
    }
}

export default new TipoObraService();